import { Serv_send } from './Serv.socketClient'
import type { ReportGetOutput } from '../../../shared/domain/reports/types.no-deps'

export function Serv_getReport(id: number, includeDeleted = false, includeLanguage?: boolean, language?: string) {
    return Serv_send('v2.reports.get', {
        id,
        includeDeleted,
        includeLanguage,
        language,
    }) as Promise<ReportGetOutput>
}

export function Serv_getReportByClientId(reportClientId: string) {
    return Serv_send('v2.reports.get', {
        reportClientId,
    }) as Promise<ReportGetOutput>
}

export function Serv_editReportStatus(id: number, status: number, signature?: string, signedAtTime?: Date) {
    return Serv_send('v2.reports.editStatus', { id, status, signature, signedAtTime })
}
